import { render } from "./CashierMenuListComponent.vue?vue&type=template&id=3479deed&scoped=true"
import script from "./CashierMenuListComponent.vue?vue&type=script&lang=js"
export * from "./CashierMenuListComponent.vue?vue&type=script&lang=js"

import "./CashierMenuListComponent.vue?vue&type=style&index=0&id=3479deed&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3479deed"]])

export default __exports__